module.exports = function () {
  return {
    GithubAPI: false
  };
};
